// Axios and configuration
import Axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";

// Interfaces
import I_BaseAPIResponse from "src/common_interfaces/I_BaseAPIResponse";

// Interfaces
import { I_ApprovalRecordType } from "../interfaces";

// Utilities
import snackBar from "src/utilities/snackBar/SnackBar";

/**
 * Fetches the list of approval record types (e.g., Lease, SafetyEvent).
 *
 * @returns An array of record types, or an empty array on failure
 */
const GetApprovalRecordTypes = async (): Promise<I_ApprovalRecordType[]> => {
  try {
    const response = await Axios.get<I_BaseAPIResponse<I_ApprovalRecordType[]>>(
      `${process.env.REACT_APP_API_URL}/api/approval/recordtypes`,
      AxiosConfig.configValue("min")
    );

    if (response.data.HasError) {
      snackBar({
        type: "error",
        text: response.data.ErrorMessage,
        timeout: 4000,
      });
      return [];
    }

    return response.data.Data;
  } catch (error) {
    console.error("GetApprovalRecordTypes failed:", error);
    snackBar({
      type: "error",
      text: "Failed to get approval record types",
      timeout: 4000,
    });
    return [];
  }
};

export default GetApprovalRecordTypes;
